import axios from 'axios';
import { IResponse } from '~/services/api/types';
import { IDashboardCounters } from './types';

const apiUrl = 'dashboard';

export const getCounters = (): IResponse<IDashboardCounters> =>
  axios({
    method: 'get',
    url: `${apiUrl}/counters`,
  });

export default {};
